// ROW 1 — PAGE TOOLS ('none' selection kind). CONCEPT §1: nothing selected →
// Row 1 shows the page.
//
// B0 (app-bar lane, 2026-07-21 — owner: "the poster needs a properties
// section"): the page controls LEFT this morph for Bar 0, the always-visible
// app bar above the rows (ribbon/AppBar.jsx):
//   · size readout + Size… button → the Poster flyout's editable W×H inch
//     fields (plus its "All size presets…" footer, still 'page.openSizePanel');
//   · the Background paint chip → the Poster flyout (same PaintPicker
//     standard, same 'page.setBackground'/'page.setBackgroundRecipe' keys,
//     flyId 'pageBg' kept);
//   · the poster-light sun slider → the Poster flyout (same
//     'page.setPosterLight' defer + commitNow grammar, same posterLightAngle/
//     posterLightOn mirrors).
// Those surfaces are ALWAYS visible now (selection kind irrelevant), so the
// empty-state morph keeps only its honest hint — no twins, no orphan verbs.
// Margins/bleed still have no surface, so no control pretends they do.

const pageRow1 = {
  id: 'page-row1',
  row: 1,
  groups: [
    {
      id: 'pageHint',
      label: 'Tip',
      drawerSection: null,
      collapsePriority: 1,
      controls: [
        { id: 'pageHintText', kind: 'placeholder', label: 'Hint', text: 'Select something to style it' },
      ],
    },
  ],
};

export default pageRow1;
